<app-driver-activity [title]="'driverDashboard.widgets.driversEnRoute' | transloco" [count]="count" [icon]="'ph-road-horizon'" [columnHeaders]="columnHeaders"
  [filteredDriversData]="filteredDriversData" [isModal]="isModal" [componentId]="componentId"
  (toggleExpandEvent)="onExpand($event)" [isLoading]="isLoading" [isPageLoading]="isFetching" (scrollEvent)="onScroll()"
  [hasError]="hasError">
</app-driver-activity>
